/*
 *
 * ShopPickerPopup
 *
 * @version 1.0.0
 * @author Giorgia Cuozzo
 * @since 01-Apr-2025
*/

import ShopPickerPopup from './ShopPickerPopupContainer'

export default ShopPickerPopup
